<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgements">
<h1>Acknowledgements</h1>
<p>My father-in-law and mother-in-law for not letting me give up when I had had enough. Thanking them for their ongoing support, always. For everyone else who had helped me to complete my degree whether it was a small or a big contribution. Thank you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?adf02f66